import { FormControl, Grid, InputLabel, MenuItem, TextField, Typography } from '@mui/material';
import { useEffect } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import * as yup from "yup";
import { useAppDispatch } from '../../../../../Redux/store';
import { languages } from '../../../../../Types/General';
import { PersonalInfoSchema } from '../../../../../Schemas/ResumeSchemas';
import { setNextDisabled } from '../../Slices/TalentProfileCreationSlice';
import { useMobileView } from '../../../../../Hooks/useMobileView';

interface PersonalInformationForm {
    PrimaryLanguage: string;
    SecondaryLanguage: string;
    Summary: string;
}

interface IProps {
    personalInfoForm: UseFormReturn<yup.InferType<typeof PersonalInfoSchema>>
}

export const PersonalInformation = ({ personalInfoForm }: IProps) => {
    /* ******************** Hooks ******************** */
    const dispatch = useAppDispatch();
    const {
        control,
        formState: { isValid }
    } = personalInfoForm;
    /* ******************** Variables ******************** */
    const { isMobileView } = useMobileView();
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    useEffect(() => {
        isValid ? dispatch(setNextDisabled(false)) : dispatch(setNextDisabled(true));
    }, [isValid])
    /* ******************** JSX ******************** */
    return (
        <Grid container gap={'20px'}>
            <Typography variant='lora-title-large' color={'primary'} fontWeight={'bold'}>Add your personal information</Typography> 
            <Grid item display={"flex"} flexDirection={isMobileView ? "column": "row"} gap={"12px"} width={"100%"}>
                <Grid item display={"flex"} flexDirection={"column"} flex={1}>
                    <Typography variant='body-small' color={'black.200'} marginBottom={1}>Primary language</Typography>  
                    <Controller
                        name="primaryLanguage"
                        control={control}
                        rules={{required: true}}
                        render={({ field }) =>( 
                            <FormControl>   
                                <InputLabel sx={{opacity: 1}}>{field.value ?"":"Select language"}</InputLabel>                   
                                <TextField
                                    {...field}
                                    select
                                    // error={hasErrors(field.name, errors)}
                                    fullWidth
                                >
                                    {
                                        languages.map((language) => (
                                            <MenuItem key={language} value={language}>
                                                {language}
                                            </MenuItem>
                                        ))
                                    }
                                </TextField>
                            </FormControl>
                        )}
                    />   
                </Grid>
                <Grid item display={"flex"} flexDirection={"column"} flex={1}>
                    <Typography variant='body-small' color={'black.200'} marginBottom={1}>Secondary language (optional)</Typography>
                    <Controller
                        name="secondaryLanguage"
                        control={control}
                        render={({ field }) =>( 
                            <FormControl>   
                                <InputLabel sx={{opacity: 1}}>{field.value ?"":"Select language"}</InputLabel>                   
                                <TextField
                                    {...field}
                                    select
                                    // error={hasErrors(field.name, errors)}
                                    fullWidth
                                >
                                    {
                                        languages.map((language) => (
                                            <MenuItem key={language} value={language}>
                                                {language}
                                            </MenuItem>
                                        ))
                                    }
                                </TextField>
                            </FormControl>
                        )}
                    />  
                </Grid>
            </Grid>
            <Grid item xs display={"flex"} flexDirection={"column"}>
                    <Typography variant='body-small' color={'black.200'} marginBottom={1}>About me</Typography>
                    <Controller
                        name="summary"
                        control={control}
                        rules={{required: true}}
                        render={({ field }) =>(            
                            <TextField
                                {...field}
                                placeholder='Add a short description about yourself'
                                fullWidth
                                multiline
                                maxRows={5}
                                // error={hasErrors(field.name, errors)}
                                sx={{
                                    width: "100%",
                                    '& .MuiInputBase-input': {
                                      maxHeight: '126px'
                                    }
                                }}
                            />
                        
                        )}
                    />  
            </Grid>
        </Grid>
    )
}